<template>
  <div id="home">
    <!--<div class="container">
      <div class="row">
        <div class="col">
          <div class="row">
            <div class="col-md-6 wow fadeInLeft" data-wow-delay="0.2s" data-wow-duration="2s">
              <img class="img-fluid plant-img" src="~@/assets/images/banner-plant.png">
            </div>
            <div class="col-md-6 banner-title-cont my-auto wow fadeInDown" data-wow-delay="0.6s" data-wow-duration="2s">
              <div class="row">
                <div class="col-12 text-center text-md-start mb-5 mb-md-0">
                  <h1 class="banner-title">Plants made easy</h1>
                  <p class="banner-subtitle">We help you discover the best plants for your space, <br class="d-none d-md-none d-lg-none d-xl-block">
                    delivers them to your door and helps you look after them.</p>
                  <a href="https://shop.bloomsnature.com/" type="button" class="btn btn-link ctr-btn">Shop Plants Now <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i>
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>-->

    <div class="container-fluid">
      <div class="row">
        <div class="col-12 px-0">
          <img class="img-fluid" src="~@/assets/images/Merdeka-03-R2.jpg">
        </div>
      </div>
    </div>

    <section class="section-one pt-5" style="position: relative">
      <div class="vertical-title">Plants</div>
      <div class="container">
        <div class="row">
          <div class="col-12 wow fadeInDown" data-wow-duration="2s">
            <div class="title text-center">Shop The Look</div>
            <div class="subtitle text-center">We've included the pots we'd recommend for each of these plants <br class="d-none d-md-block">
              to make it really easy for you to recreate this look at home.</div>
          </div>
          <div class="col-12 mt-5 wow fadeInDown" data-wow-delay="0.6s" data-wow-duration="2s">
            <carousel :per-page="3" :per-page-custom="[[100, 1], [768, 2], [1025, 3] ]" :pagination-enabled="true" :center-mode="false" :scroll-per-page="true" :navigation-enabled="true" :pagination-active-color="'#0b743b'">
              <slide>
                <div class="row">
                  <a href="https://shop.bloomsnature.com/product/calathea-orbifolia-apple/" class="col-12">
                    <img class="img-fluid" src="~@/assets/images/plant-1.jpg">
                    <div class="row">
                      <div class="col-12 text-center">
                        <div class="plant-title mt-3">CALATHEA ORBIFOLIA – 青苹果竹芋</div>
                        <a href="https://shop.bloomsnature.com/product/calathea-orbifolia-apple/" type="button" class="btn btn-link ctr-btn text-center">Shop Plants Now <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
                      </div>
                    </div>
                  </a>
                </div>
              </slide>
              <slide>
                <div class="row">
                  <a href="https://shop.bloomsnature.com/product/rubber-plant/" class="col-12">
                    <img class="img-fluid" src="~@/assets/images/plant-2.jpg">
                    <div class="row">
                      <div class="col-12 text-center">
                        <div class="plant-title mt-3">RUBBER PLANT – 黑金刚</div>
                        <a href="https://shop.bloomsnature.com/product/rubber-plant/" type="button" class="btn btn-link ctr-btn text-center">Shop Plants Now <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
                      </div>
                    </div>
                  </a>
                </div>
              </slide>
              <slide>
                <div class="row">
                  <a href="hhttps://shop.bloomsnature.com/product/spider-plant-%e5%90%8a%e5%85%b0/" class="col-12">
                    <img class="img-fluid" src="~@/assets/images/plant-3.jpg">
                    <div class="row">
                      <div class="col-12 text-center">
                        <div class="plant-title mt-3">Spider Plant – 吊兰</div>
                        <a href="https://shop.bloomsnature.com/product/spider-plant-%e5%90%8a%e5%85%b0/" type="button" class="btn btn-link ctr-btn text-center">Shop Plants Now <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
                      </div>
                    </div>
                  </a>
                </div>
              </slide>
            </carousel>
          </div>
          <div class="row">
            <div class="col-12">
              <div class="space"></div>
            </div>
          </div>

          <!--<div class="col-12 mt-5 wow fadeInRight" data-wow-duration="2s">
            <div class="row">
              <div class="col-md-6">
                <img class="img-fluid" src="~@/assets/images/feature_plant_1.png">
              </div>
              <div class="col-md-6 desc-col-right my-auto">
                <div class="title">Bundle Deals</div>
                <div class="subtitle">We've gathered some of our most popular plants <br class="d-none d-md-none d-lg-none d-xl-block">
                  into sets to suit all types of plant parent.</div>
                <a href="https://shop.bloomsnature.com/" type="button" class="btn btn-link ctr-btn text-center">Find Your Match <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
              </div>
            </div>
          </div>-->

          <div class="col-12 mt-5 wow fadeInLeft" data-wow-delay="0.4s" data-wow-duration="2s">
            <div class="row">
              <div class="col-md-6 desc-col-right my-auto order-2 order-md-1">
                <div class="title">Doorstep Delivery</div>
                <div class="subtitle">We carefully hand-pick and deliver every plant <br class="d-none d-md-none d-lg-none d-xl-block">
                  to your doorstep to ensure the highest quality of our plant.</div>
                <a href="https://shop.bloomsnature.com/" type="button" class="btn btn-link ctr-btn text-center">Order Now <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
              </div>
              <div class="col-md-6 order-1 order-md-2">
                <img class="img-fluid" src="~@/assets/images/home-img.jpg">
              </div>
            </div>
          </div>

          <div class="row">
            <div class="col-12">
              <div class="space"></div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-two pt-5" style="position: relative">
      <div class="vertical-title-review">Reviews</div>
      <div class="container">
        <div class="row">
          <div class="col-12 wow fadeInDown" data-wow-duration="2s">
            <div class="title text-center">Customer Reviews</div>
            <div class="subtitle text-center">Let our customers speak for us</div>
          </div>
          <div class="col-12 mt-5 mb-5 wow fadeInDown" data-wow-duration="2s">
            <carousel :per-page="3" :per-page-custom="[[100, 1], [768, 2], [1025, 3]]" :pagination-enabled="true" :center-mode="false" :scroll-per-page="true" :navigation-enabled="true" :pagination-active-color="'#0b743b'">
              <slide>
                <div class="row">
                  <div class="col-12 review-col text-center p-0 p-md-5">
                    <div class="row">
                      <div class="col-12">
                        <i class="fa fa-user-o icon-user" aria-hidden="true"></i>
                      </div>
                      <div class="col-12 mt-3">
                        <div class="name">Atieq Rahim</div>
                      </div>
                      <div class="col-12">
                        <star-rating v-bind:increment="0.5"
                                     v-bind:max-rating="5"
                                     inactive-color="#f0f0f0"
                                     active-color="#F1592B"
                                     v-bind:star-size="40"
                                     v-bind:show-rating="false"
                                     :rounded-corners="true"
                                     :border-width="4"
                                     border-color="#F1592B"
                                     v-bind:rating="4"
                        >
                        </star-rating>
                      </div>
                      <div class="col-12 mt-3">
                        <p>Happy to have it...
                          plants so healthy and combination
                          of plants wisely picked by</p>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div class="row">
                  <div class="col-12 review-col text-center p-0 p-md-5">
                    <div class="row">
                      <div class="col-12">
                        <i class="fa fa-user-o icon-user" aria-hidden="true"></i>
                      </div>
                      <div class="col-12 mt-3">
                        <div class="name">Ashikin</div>
                      </div>
                      <div class="col-12">
                        <star-rating v-bind:increment="0.5"
                                     v-bind:max-rating="5"
                                     inactive-color="#f0f0f0"
                                     active-color="#F1592B"
                                     v-bind:star-size="40"
                                     v-bind:show-rating="false"
                                     :rounded-corners="true"
                                     :border-width="4"
                                     border-color="#F1592B"
                                     v-bind:rating="5"
                        >
                        </star-rating>
                      </div>
                      <div class="col-12 mt-3">
                        <p>The plant came in a great condition,
                          and so far it is growing healthily and
                          it's very beautiful, thank you<3</p>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
              <slide>
                <div class="row">
                  <div class="col-12 review-col text-center p-0 p-md-5">
                    <div class="row">
                      <div class="col-12">
                        <i class="fa fa-user-o icon-user" aria-hidden="true"></i>
                      </div>
                      <div class="col-12 mt-3">
                        <div class="name">Nurul</div>
                      </div>
                      <div class="col-12">
                        <star-rating v-bind:increment="0.5"
                                     v-bind:max-rating="5"
                                     inactive-color="#f0f0f0"
                                     active-color="#F1592B"
                                     v-bind:star-size="40"
                                     v-bind:show-rating="false"
                                     :rounded-corners="true"
                                     :border-width="4"
                                     border-color="#F1592B"
                                     v-bind:rating="5"
                        >
                        </star-rating>
                      </div>
                      <div class="col-12 mt-3">
                        <p>My plant received in very good
                          condition. Fast shipping and stay
                          healthy. Love it!</p>
                      </div>
                    </div>
                  </div>
                </div>
              </slide>
            </carousel>
          </div>
        </div>
      </div>
    </section>

    <section class="section-three pt-5" style="background-color: #fff; position: relative">
      <div class="vertical-title-about-us">About Us</div>
      <div class="container">
        <div class="row">
          <div class="col-12 wow fadeInDown" data-wow-duration="2s">
            <div class="title text-center">Get To Know Us</div>
            <div class="subtitle text-center">We founded Blooms Nature with one goal in mind: <br>
              providing a high-quality, smart, and reliable online store</div>
          </div>
          <div class="col-12">
            <div class="space"></div>
          </div>
          <div class="col-12 text-center wow fadeInDown" data-wow-duration="2s" style="position: relative; z-index: 1">
            <img class="img-fluid" src="~@/assets/images/logo.png">
          </div>
          <div class="col-12 text-center" style="position: relative; z-index: 1">
            <p class="desc-about-us mt-4 wow fadeInDown" data-wow-duration="2s">We founded Blooms Nature with one goal in mind: to provide a high-quality,  <br class="d-none d-md-none d-lg-none d-xl-block">
              reliable and easy-to-access online store for everyone. We believe that  <br class=" d-none d-md-none d-lg-none d-xl-block">
              indoor plants don’t just look good. They make us feel good mentally and physically, too.  <br class="d-none d-md-none d-lg-none d-xl-block">
              Check it out for yourself!</p>
          </div>
          <div class="col-12">
            <div class="large-space"></div>
          </div>
        </div>
      </div>
    </section>

    <section class="section-four">
      <div class="container insta-cont wow fadeInUpBig" data-wow-duration="1s">
        <div class="row">
          <div class="col-12">
            <div class="title text-center">Our Instagram</div>
            <div class="subtitle text-center">Visit us for more options</div>
          </div>
          <div class="col-12 text-center mt-5 insta-col">
            <ul class="instagram-list" v-if="instagram_feeds.length > 0">
              <li v-for="(list, index) in instagram_feeds" v-bind:key="list.id" v-if="index < 4">
                <a :href="list.permalink"><img width="260" height="260" class="img-fluid" :src="list.thumbnail_url" v-if="list.thumbnail_url"></a>
                <a :href="list.permalink"><img width="260" height="260" class="img-fluid" :src="list.media_url" v-if="!list.thumbnail_url"></a>
              </li>
            </ul>
          </div>
          <div class="col-12 text-center">
            <a target="_blank" href="https://www.instagram.com/blooms.nature_/" type="button" class="btn btn-link ctr-btn text-center">View More <i class="fa fa-arrow-right ms-2 icon" aria-hidden="true"></i></a>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="space"></div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {WOW} from "wowjs";
export default {
  name: 'Home',
  components: {

  },
  data() {
    return {
      instagram_feeds: []
    }
  },
  mounted() {
    const wow = new WOW();
    this.getInstagramFeed();
    wow.init();
  },
  methods: {
    getInstagramFeed () {
      let me = this;
      this.$axios.get('https://graph.facebook.com/v10.0/17841407545741617/media?fields=thumbnail_url,media_url,permalink&access_token=EAAED9Ax9Y5sBAMKCilRUT0QwRYBQijvzSPFvcJd0jryZA0rA7EKEIlTtIvo0KWE2voLWT7BguzcZB5InsmbsTZCJlqji9mFDnJOaA7ou6YITTpJTjYvXEifLrhOtxJul4AMrnZBjcHBWh9AmkyPQrey3ieBETHoqNCN2jCj4nhtlKdOZCZAls2')
          .then(function (response) {
            // handle success
            me.instagram_feeds = response.data.data;
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          })
          .then(function () {
            // always executed
          });
    }
  }
}
</script>
